// Simple example of a React "smart" component

import { connect } from 'react-redux';
import EditTour from '../components/EditTour';
import * as actions from '../actions/editTourActionCreators';

// Which part of the Redux global state does our component want to receive as props?
const mapStateToProps = (state) => ({
  csrfToken: state.csrfToken,
  team: state.team,
  currentUser: state.currentUser,
  tour: state.tour,
  tourDates: state.tourDates
});

const mapDispatchToProps = (dispatch) => {
  return {
    tourChanged: (tour) => dispatch(actions.tourChanged(tour)),
    tourDatesChanged: (tourDates) => dispatch(actions.tourDatesChanged(tourDates))
  }
};

// Don't forget to actually use connect!
// Note that we don't export HelloWorld, but the redux "connected" version of it.
// See https://github.com/reactjs/react-redux/blob/master/docs/api.md#examples
export default connect(mapStateToProps, mapDispatchToProps)(EditTour);
